import React, { FC, useState } from 'react';
import { Create, SimpleForm, useCreatePath, useNotify, useRedirect } from 'react-admin';
import { Container, Typography } from '@mui/material';
import { SubjectsCreateCard } from './SubjectsCreateCard';
import ShsFormToolbar from 'src/components/common/ShsFormToolbar';
import WithRole from '../../common/WithRole';
import { ShsReturnButton } from '../../common';
import { NOTIFICATION_OPTIONS_SUCCESS, Resource } from 'src/constants';
import { UserRole } from '../../../auth/types';

const SubjectCreate: FC = () => {
    const redirect = useRedirect();
    const notify = useNotify();
    const createPath = useCreatePath();
    const [serverError, setServerError] = useState<string | null>(null);

    const handleCancelBtnClick = () => {
        redirect(createPath({ resource: Resource.SUBJECTS, type: 'list' }));
    };

    const transform = (data: any) => ({
        ...data,
        name: data.name.trim()
    });

    return (
        <WithRole roles={[UserRole.SYSTEM_ADMIN]}>
            <Container>
                <ShsReturnButton to="/subjects" label="Назад до навчального плану" />
                <Typography fontSize={40} fontWeight={700} sx={{ mb: 3 }}>
                    Додати предмет
                </Typography>
                <Create
                    transform={transform}
                    mutationOptions={{
                        onSuccess: () => {
                            notify('Предмет успішно додано', NOTIFICATION_OPTIONS_SUCCESS);
                            redirect('list', 'subjects');
                        },
                        onError: (error: Error) => setServerError(error.message)
                    }}
                    sx={{ '.RaCreate-card': { backgroundColor: 'transparent', boxShadow: 'none' } }}>
                    <SimpleForm toolbar={false} mode="onBlur" sx={{ padding: 0 }}>
                        <SubjectsCreateCard serverError={serverError} />
                        <ShsFormToolbar handleCancel={handleCancelBtnClick} submitLabel="Додати предмет" />
                    </SimpleForm>
                </Create>
            </Container>
        </WithRole>
    );
};

export default SubjectCreate;
